<template>
	<div id="NotFound">
		<section>
			<div class="container-md">
				<div class="row">
					<div class="col text-center">
						<h2>Die gewünschte Seite  existiert nicht!!!</h2>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name:"not-found"
}
</script>

<style lang="scss">
#NotFound {
	margin: 4rem 0 0;
}
</style>

